import {Cell} from 'notebook/tables/TableConstants';

/**
 * Checks if a cell is merged based on its mergeColSpan and mergeRowSpan properties.
 * A cell is considered merged if either of these properties is greater than 1.
 */
export default function isMergedCell(cell: Cell): boolean {
  return (cell.mergeColSpan ?? 1) > 1 || (cell.mergeRowSpan ?? 1) > 1;
}
